export class NuevaSucursalDTO {
    constructor(
        public nombre: string,
        public direccion: string,
        public idComuna: number,
        public telefono: string
    ) {
        this.nombre=nombre;
        this.direccion=direccion;
        this.idComuna=idComuna;
        this.telefono=telefono;
    }
}
